import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  readReportTemplates,
  setPendingTemplateId,
  REPORT_TEMPLATE_APPLY_EVENT,
  REPORT_TEMPLATES_CHANGED_EVENT,
} from "../utils/reportTemplatesStorage";

export function HeaderReportTemplates({ showNavIcons }) {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState(() => readReportTemplates());

  const refresh = useCallback(() => {
    setTemplates(readReportTemplates());
  }, []);

  useEffect(() => {
    refresh();
    const onChanged = () => refresh();
    window.addEventListener(REPORT_TEMPLATES_CHANGED_EVENT, onChanged);
    return () =>
      window.removeEventListener(REPORT_TEMPLATES_CHANGED_EVENT, onChanged);
  }, [refresh]);

  if (templates.length === 0) {
    return null;
  }

  const onSelect = (id) => {
    setPendingTemplateId(id);
    navigate("/allreport");
    window.dispatchEvent(new Event(REPORT_TEMPLATE_APPLY_EVENT));
  };

  return (
    <div className="header-templates-wrap">
      <button
        type="button"
        className="header-notes-trigger header-templates-trigger"
        aria-haspopup="menu"
        aria-label="Шаблоны отчётов"
        title="Шаблоны"
      >
        {showNavIcons ? (
          <span className="header-templates-trigger-short" aria-hidden="true">
            Ш
          </span>
        ) : (
          <span>Шаблоны</span>
        )}
      </button>
      <ul className="header-templates-menu" role="menu">
        {templates.map((tpl) => (
          <li key={tpl.id} role="none">
            <button
              type="button"
              role="menuitem"
              className="header-templates-menu-item"
              onClick={() => onSelect(tpl.id)}
            >
              {tpl.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
